import React from 'react'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'

import CrashForm from './Forms/statusForms/CrashForms';
import RezultForms from './Forms/statusForms/RezultForms';
import Header from './Header';
import SignIn from './Forms/SignIn';
import { backPrevForm } from '../store/action/stateForm';

const renderComponent = (type, statusCode) => {
  switch (type) {
    case 'SignIn':
      return <SignIn />
    case 'RezultForms':
      return <RezultForms />
    case 'Crash':
      return <CrashForm statusCode={statusCode}/>
    default:
      return '';
  }
}
const checkMethodUrl = (nameForm, errorSubmit, goBack) => {
  if(errorSubmit)
    goBack()
  else if(nameForm === 'SignIn' || nameForm === 'Crash')
    window.location.assign('#q=goback')
  else 
    window.location.assign('#q=success')
}
const SystemContainer = ({nameForm, errorSubmit, goBack, statusCode}) => {
  return (
    <React.Fragment>
      <Header onClickBack={() => checkMethodUrl(nameForm, errorSubmit, goBack)} title=''/>
      <div className="system-container">
        {renderComponent(nameForm, statusCode)}
      </div>
    </React.Fragment>
  )
}

SystemContainer.propTypes = {
  nameForm: PropTypes.string.isRequired,
  errorSubmit: PropTypes.bool.isRequired,
  goBack: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  errorSubmit: state.stateForm.errorSubmitDate,
  statusCode: state.stateForm.codeStatus
})

const mapDispatchToProps = dispatch => ({
  goBack: () => dispatch(backPrevForm())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SystemContainer))